import type {
  TaskDetail,
  TaskAttachment,
  TaskRelatedData,
  ActivityDto,
  ActivityDtoPagedResult,
} from '../types';

const MOCK_ASSIGNEE = {
  id: 'user-1',
  name: 'Guillermo Sánchez',
  avatarUrl: undefined,
  color: '#6366f1',
};

const MOCK_ATTACHMENTS: TaskAttachment[] = [
  {
    id: 'att-1',
    taskId: 'task-1',
    name: 'design-mockup.png',
    url: 'https://placehold.co/400x300/6366f1/ffffff?text=Mockup',
    thumbnailUrl: 'https://placehold.co/400x300/6366f1/ffffff?text=Mockup',
    type: 'image',
    size: 245_000,
    uploadedAt: '2026-02-13T10:30:00Z',
    uploadedBy: MOCK_ASSIGNEE,
  },
  {
    id: 'att-2',
    taskId: 'task-1',
    name: 'requirements-spec.pdf',
    url: '#',
    thumbnailUrl: null,
    type: 'document',
    size: 1_200_000,
    uploadedAt: '2026-02-14T14:00:00Z',
    uploadedBy: MOCK_ASSIGNEE,
  },
  {
    id: 'att-3',
    taskId: 'task-1',
    name: 'data-export.csv',
    url: '#',
    thumbnailUrl: null,
    type: 'other',
    size: 54_000,
    uploadedAt: '2026-02-15T09:00:00Z',
    uploadedBy: null,
  },
];

export const MOCK_TASK_DETAIL: TaskDetail = {
  id: 'task-1',
  title: 'Diseñar dashboard principal',
  description: '',
  status: {
    id: 'status-1',
    name: 'Por hacer',
    type: 'todo',
    color: '#94a3b8',
    order: 0,
    boardId: 'board-1',
  },
  priority: 'urgent',
  assignee: MOCK_ASSIGNEE,
  dueDate: { date: new Date(Date.now() + 86_400_000).toISOString().split('T')[0] },
  startDate: undefined,
  orgId: 'org-1',
  projectId: 'project-1',
  groupId: 'group-1',
  subtaskCount: 1,
  isCompleted: false,
  order: 0,
  subtasks: [
    {
      id: 'task-2',
      title: 'Documentar API endpoints',
      description: '',
      status: {
        id: 'status-2',
        name: 'En progreso',
        type: 'in-progress',
        color: '#f59e0b',
        order: 1,
        boardId: 'board-1',
      },
      priority: 'high',
      assignee: { id: 'user-2', name: 'Mónica Estrada', avatarUrl: undefined, color: '#10b981' },
      dueDate: { date: new Date().toISOString().split('T')[0] },
      orgId: 'org-1',
      projectId: 'project-1',
      groupId: 'group-1',
      subtaskCount: 0,
      isCompleted: false,
      order: 0,
    },
  ],
  tags: [
    {
      id: 'tag-1',
      projectId: 'project-1',
      name: 'Desarrollo',
      color: 'red-ember',
      createdAt: '2026-01-01T00:00:00Z',
    },
    {
      id: 'tag-2',
      projectId: 'project-1',
      name: 'Febrero',
      color: 'pink-flamingo',
      createdAt: '2026-01-01T00:00:00Z',
    },
  ],
  attachments: MOCK_ATTACHMENTS,
  estimatedMinutes: 90,
  timer: { seconds: 0, running: false },
  createdBy: MOCK_ASSIGNEE,
  createdAt: '2026-02-13T08:00:00Z',
};

export const MOCK_RELATED: TaskRelatedData = {
  children: MOCK_TASK_DETAIL.subtasks ?? [],
  related: [],
};

export function getMockTaskDetail(taskId: string): TaskDetail {
  return { ...MOCK_TASK_DETAIL, id: taskId };
}

export function getMockRelated(taskId: string): TaskRelatedData {
  return {
    children: (MOCK_TASK_DETAIL.subtasks ?? []).map((t) => ({ ...t, projectId: taskId })),
    related: [],
  };
}

export function getMockAttachments(taskId: string): TaskAttachment[] {
  return MOCK_ATTACHMENTS.map((a) => ({ ...a, taskId }));
}

const MOCK_ACTIVITIES: ActivityDto[] = [
  {
    id: 'act-1',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_created',
    category: 'general',
    actorId: 'user-3',
    actorName: 'Sara Alejandra Martínez',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'Diseñar wireframes de onboarding',
    oldValue: null,
    newValue: null,
    metadata: null,
    createdAt: '2026-02-13T08:00:00Z',
  },
  {
    id: 'act-2',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_assigned',
    category: 'assignment',
    actorId: 'user-3',
    actorName: 'Sara Alejandra Martínez',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: null,
    oldValue: null,
    newValue: 'Guillermo Sánchez',
    metadata: null,
    createdAt: '2026-02-13T08:05:00Z',
  },
  {
    id: 'act-3',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_updated',
    category: 'general',
    actorId: 'user-1',
    actorName: 'Guillermo Sánchez',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'DueDate',
    oldValue: null,
    newValue: '10 Feb',
    metadata: null,
    createdAt: '2026-02-14T09:00:00Z',
  },
  {
    id: 'act-4',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_updated',
    category: 'general',
    actorId: 'user-1',
    actorName: 'Guillermo Sánchez',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'EstimatedHours',
    oldValue: '4h',
    newValue: '8h',
    metadata: null,
    createdAt: '2026-02-14T11:30:00Z',
  },
  {
    id: 'act-5',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_moved',
    category: 'status_change',
    actorId: 'user-2',
    actorName: 'Ana García',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'En revisión',
    oldValue: 'En progreso',
    newValue: 'En revisión',
    metadata: null,
    createdAt: '2026-02-15T10:00:00Z',
  },
  {
    id: 'act-6',
    taskId: null,
    taskTitle: 'Diseñar wireframes de onboarding',
    actionType: 'task_priority_changed',
    category: 'general',
    actorId: 'user-1',
    actorName: 'Guillermo Sánchez',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: null,
    oldValue: 'High',
    newValue: 'Urgent',
    metadata: null,
    createdAt: '2026-02-15T14:20:00Z',
  },
];

export function getMockActivityResult(
  taskId: string,
  page: number,
  pageSize: number,
): ActivityDtoPagedResult {
  const items = MOCK_ACTIVITIES.map((a) => ({ ...a, id: `${taskId}-${a.id}`, taskId }));
  const start = (page - 1) * pageSize;
  const pageItems = items.slice(start, start + pageSize);
  return {
    items: pageItems,
    page,
    pageSize,
    totalCount: items.length,
    totalPages: Math.ceil(items.length / pageSize),
    hasNextPage: start + pageSize < items.length,
  };
}
